import React from 'react'
import { TextInput } from 'react-admin'
import { parseCurrency } from '../utils'

const PriceInput = ({ source, label = "", precision = 2, style = {}, ...props }) => {
    return (
        <TextInput
            style={style}
            source={source}
            label={label}
            format={(value) => {
                // Formato pt-BR: vírgula decimal e ponto de milhar. Antes o
                // caminho preenchido usava toFixed, que devolve ponto decimal,
                // e o campo mostrava "R$ 5.00" — enquanto o caminho vazio já
                // mostrava "R$ 0,00". O componente contradizia a si mesmo.
                //
                // Seguro para o parse: parseCurrency remove TODO não-dígito e
                // divide por 10^precision, então "R$ 1.234,56" volta 1234.56.
                const amount = !value ? 0 : Number(value);
                return `R$ ${amount.toLocaleString("pt-BR", {
                    minimumFractionDigits: precision,
                    maximumFractionDigits: precision,
                })}`;
            }}
            parse={(value) => {
                if (!value || value === '') {
                    return 0;
                }
                return parseCurrency(value, precision);
            }}
            {...props}
        />
    );
}

export default PriceInput;
